export type CanvasEnv = { canvas: HTMLCanvasElement; context: CanvasRenderingContext2D; };

let sharedEnv: CanvasEnv | null = null;

export function setSharedEnv(env: CanvasEnv) { sharedEnv = env; }
export function getSharedEnv(): CanvasEnv {
    if (sharedEnv) return sharedEnv;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d')!;
    return { canvas, context };
}